module.exports = __webpack_public_path__ + "static/media/charts.8fe43111.svg";